import React from "react";
import autobind from "react-autobind";
import {
  ListTable,
  Actions,
  ActionButton,
  Modal,
  PageTitle,
  PencilIcon,
} from "@gsd/backoffice-ui";
import { Column } from "react-table";
import { Col, Row, Button } from "reactstrap";
import ColumnsSettings from "./TableSettings";
import FormRole from "./FormRole";

type Props = {
  dataElements: Array<unknown>;
  loading?: boolean;
  upsertEntity: Function;
};

type State = {
  activeDataElement: any;
  readOnly: boolean;
  editModalOpen: boolean;
};

class Roles extends React.Component<Props, State> {
  state: State;
  constructor(props: Props) {
    super(props);
    this.state = {
      activeDataElement: null,
      readOnly: false,
      editModalOpen: false,
    };
    autobind(this);
  }

  tableActions: Array<Column> = [
    {
      Header: "Modifica",
      Cell: (row) => {
        return (
          <Actions>
            <ActionButton
              icon={PencilIcon}
              onClick={() => this.handleEdit(row.original)}
            />
          </Actions>
        );
      },
      width: 75,
      sortable: false,
    },
  ];

  handleEdit(row?: any) {
    this.setState({
      ...this.state,
      editModalOpen: true,
      activeDataElement: row || {},
    });
  }

  onCloseModal() {
    this.setState({
      ...this.state,
      editModalOpen: false,
    });
  }

  onSaveData(values: any) {
    this.props.upsertEntity(values);
    this.onCloseModal();
  }

  render() {
    const { dataElements } = this.props;
    const { editModalOpen, activeDataElement = {}} = this.state;

    return (
      <React.Fragment>
        <Row className="pb-3">
          <Col xs="9">
            <PageTitle title="Ruoli - ACL" />
          </Col>
          <Col xs="3">
            <Button color="primary" size="lg" block onClick={this.handleEdit}>
              Nuovo Ruolo
            </Button>
          </Col>
        </Row>
        <ListTable
          columns={ColumnsSettings}
          data={dataElements}
          actions={this.tableActions}
        />
        <Modal
          showModal={editModalOpen}
          onClose={() => this.onCloseModal()}
          size="lg"
          title="Modifica Ruolo"
        >
          <FormRole
            initialValues={activeDataElement}
            onSubmit={this.onSaveData}
          />
        </Modal>
      </React.Fragment>
    );
  }
}
export default Roles;
